module.exports = __webpack_public_path__ + "img/flop2.31ee8a48.png";